import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import ToastCustom from '../components/toast';
import { useNavigate } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('https://app.mirzawaleed.com/getProducts.php');
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleEdit = (product) => {
    navigate(`/editproduct/${product.id}`); 
  };

  const handleDelete = async (productId) => {
    try {
      // Sending the delete request to the server
      const response = await fetch(`https://app.mirzawaleed.com/deleteproduct.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: productId }),
      });
  
      const result = await response.json();
  
      if (result.success) {
        setToastMessage(`Product with ID ${productId} deleted successfully.`);
        
        setProducts(products.filter(product => product.id !== productId));
      } else {
        setToastMessage(`Failed to delete product with ID ${productId}.`);
      }
    } catch (error) {
      console.error('Error deleting product:', error);
      setToastMessage('An error occurred while deleting the product.');
    } finally {
      setTimeout(() => setToastMessage(null), 3000);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const addNewProduct = () => {
    navigate('/addproduct'); 
  };

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) return <p>Loading products...</p>;

  return (
    <>
      <Header />
      <br></br>
      <div style={{ padding: '80px 20px 20px 20px' }}>
        <h1 style={{ textAlign: 'center' }}>Products</h1>
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <input 
            type="text" 
            placeholder="Search products by name..." 
            value={searchQuery} 
            onChange={handleSearchChange}
            style={searchInputStyle}
          />
          <button onClick={addNewProduct} style={addButtonStyle}>Add New Product</button>
        </div>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {filteredProducts.map((product) => (
            <li key={product.id} style={productItemStyle}>
              <div>
                <strong>{product.name}</strong>
                <p>Price: {product.price}</p>
                <p>Quantity: {product.quantity}</p>
                {product.variants && product.variants.length > 0 && (
                  <div>
                    <h4>Variants:</h4>
                    <ul>
                      {product.variants.map((variant) => (
                        <li key={variant.id}>{variant.name} - {variant.quantity}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div style={actionButtonContainerStyle}>
                <button onClick={() => handleEdit(product)} style={actionButtonStyle('#FFC107')}><MdEdit /></button>
                <button onClick={() => handleDelete(product.id)} style={actionButtonStyle('#F44336')}><MdDelete /></button>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <Footer />
      {toastMessage && <ToastCustom message={toastMessage} onClose={() => setToastMessage(null)} />}
    </>
  );
};

const searchInputStyle = {
  padding: '10px',
  fontSize: '16px',
  marginRight: '10px',
  borderRadius: '5px',
  border: '1px solid #ccc',
};

const addButtonStyle = {
  padding: '10px 20px',
  backgroundColor: '#4CAF50',
  color: '#FFF',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
};

const productItemStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '10px',
  padding: '20px',
  backgroundColor: '#f9f9f9',
  borderRadius: '5px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
};

const actionButtonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  gap: '10px',
};

const actionButtonStyle = (backgroundColor) => ({
  padding: '5px 10px',
  backgroundColor,
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
  flexGrow: 1,
});

export default ProductsPage;
